export default __webpack_public_path__ + "static/media/bg.5265103d.png";